// --------------------------------------------------------------
// Created On: 2024-04-08
// Author: Dimitra Weinstein
//
// Last Modified: 2025-11-06
// Modified By: Zachary Thomas
//
// Copyright 2024 - 2025 © Cornell Pump Company, All Rights Reserved
// --------------------------------------------------------------

import React from "react";
import styles from "./Breadcrumbs.module.scss";

// Renders breadcrumb navigation links.
export default function Breadcrumbs(props: Props): Component {
  return (
    <nav className="breadcrumb" aria-label="breadcrumb">
      {props.bomPath.map((partNumber, i) => (
        <ol key={i} className={styles.breadcrumbList}>
          {/* Render active link based on position in bom path. */}
          <a className={styles.breadcrumbLink} onClick={() => props.onNavigate(props.bomPath.slice(0, i + 1))}>
            {props.bomPath.length > 1 ? (
              props.bomPath.length > 1 && props.bomPath[props.bomPath.length - 1] === props.bomPath[i] ? (
                <li className={styles.breadcrumb}>
                  <span className={`${styles.active} fw-bold`}>{partNumber}</span>
                </li>
              ) : (
                <>
                  <li className={styles.breadcrumb}>
                    <span>{partNumber}</span>
                    <i className="fa fa-fw fa-chevron-right" />
                  </li>
                </>
              )
            ) : (
              <li className={styles.breadcrumb}>
                <span className={`${styles.active} fw-bold`}>{partNumber}</span>
              </li>
            )}
          </a>
        </ol>
      ))}
    </nav>
  );
}

interface Props {
  bomPath: string[];
  onNavigate: (bomPath: string[]) => void;
}
